import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  Typography
} from '@mui/material';
import { FC, useState } from 'react';
import { CurrencyField } from '../../../atomic';
import { t } from 'i18next';
import { Button } from '../../../atomic/button';

type Props = {
  title: string;
  contentText: string;
  onClose: () => void;
  onCancel?: () => void;
  onConfirm?: (bulkUpdateAmount: number) => void;
  buttonDisabled?: boolean;
} & Pick<DialogProps, 'open'>;

export const CurrencyInputDialog: FC<Props> = ({
  open,
  onClose,
  onCancel,
  onConfirm,
  title,
  contentText,
  buttonDisabled
}) => {
  const [amount, setAmount] = useState(0);

  return (
    <Dialog
      PaperProps={{
        className: 'text-center shadow-900 max-w-[400px]'
      }}
      fullScreen={false}
      open={open}
      onClose={onClose}
    >
      <DialogTitle
        sx={{
          paddingTop: '24px',
          fontSize: '40px',
          lineHeight: 'normal',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography variant="h3" component="span" fontWeight={'bold'}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          paddingBottom: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <DialogContentText
          color="primary"
          sx={{
            whiteSpace: 'pre-line',
            paddingTop: '24px',
            paddingBottom: '24px'
          }}
        >
          {contentText}
        </DialogContentText>
        <div
          style={{
            display: 'inline-block',
            verticalAlign: 'middle'
          }}
        >
          <CurrencyField
            style={{ width: '130px' }}
            label={t('custom:monthly_budget')}
            shiftDecimals={2}
            returnInteger={true}
            onChange={(event) => setAmount(Number(event.target.value))}
          />
        </div>
        <div className="flex flex-col gap-4 w-full mt-6">
          <Button onClick={() => onConfirm?.(amount)} disabled={buttonDisabled}>
            {t('common:CONFIRM')}
          </Button>
          <Button variant="secondary" onClick={onCancel}>
            {t('common:CANCEL')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
